import { useEffect, useState } from "react"
import { Button } from "../ui/button"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
    DialogClose,
} from "../ui/dialog"
import { Input } from "../ui/input"
import { Label } from "../ui/label"
import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger, SelectValue } from "../ui/select"
import { Switch } from "../ui/switch"
import IndividualLimitGuidance from "./IndividualLimitGuidance"

export default function UpdateUserDialog(props) {

    const [name, setName] = useState(props.user.name);
    const [role, setRole] = useState(props.user.role);
    const [maxAuthValue, setMaxAuthValue] = useState(props.user.maxAuthValue);
    const [isActive, setIsActive] = useState(props.user.isActive ?? true);
    let close = false;

    useEffect(() => {
        setName(props.user.name);
        setRole(props.user.role);
        setMaxAuthValue(props.user.maxAuthValue);
        setIsActive(props.user.isActive ?? true);
    }, [props.user]);

    const handleSubmit = async () => {
        props.handleConfirmUpdate({
            name: name.trim(),
            role,
            maxAuthValue,
            isActive,
        });
    }

    return (
      <Dialog closed={close}>
        <DialogTrigger asChild>
            {props.children}
        </DialogTrigger>
        <DialogContent className="sm:max-w-[500px] max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle>Edit User</DialogTitle>
            <DialogDescription>
              Update settings for {props.user.email}
            </DialogDescription>
          </DialogHeader>
          <div className="grid gap-4 py-4">
            <div className="grid grid-cols-3 items-center gap-4">
              <Label htmlFor="name" className="text-right col-span-1">
                Name
              </Label>
              <Input
                id="name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="col-span-2"
              />
            </div>
            <div className="grid grid-cols-3 items-center gap-4">
              <Label htmlFor="role" className="text-right col-span-1">
                Role
              </Label>
              <div className="col-span-2">
                <Select
                        value={role} onValueChange={value => setRole(value)}
                    >
                        <SelectTrigger className="w-full">
                            <SelectValue placeholder="Select Role"/>
                        </SelectTrigger>
                        <SelectContent>
                            <SelectGroup>
                                <SelectItem value="User">User</SelectItem>
                                <SelectItem value="Admin">Admin</SelectItem>
                            </SelectGroup>
                        </SelectContent>
                    </Select>
                </div>
            </div>
            <div className="flex flex-col gap-2">
              <Label htmlFor="maxAuthValue">
                {props.isCustom === null ? 'Individual limit' : props.isCustom ? 'Individual limit (standard approvals)' : 'Max Auth Value'}
              </Label>
              <div className="flex flex-col gap-2">
                <Input
                  id="maxAuthValue"
                  aria-describedby={props.isCustom === null ? undefined : 'edit-user-limit-guidance'}
                  value={maxAuthValue}
                  onChange={(e) => setMaxAuthValue(e.target.value)}
                  type="number"
                />
                {props.isCustom !== null && <IndividualLimitGuidance isCustom={props.isCustom} id="edit-user-limit-guidance" />}
              </div>
            </div>
            <div className="grid grid-cols-3 items-center gap-4">
              <Label htmlFor="isActive" className="text-right col-span-1">
                Active
              </Label>
              <div className="col-span-2 flex items-center gap-3">
                <Switch
                  id="isActive"
                  checked={isActive}
                  onCheckedChange={setIsActive}
                />
              </div>
            </div>
          </div>
          <DialogFooter>
            <DialogClose asChild>
                <div className="flex flex-row gap-2">
                    <Button variant="outline">Cancel</Button>
                    <Button type="submit" className="bg-yavrio-green" disabled={!name.trim()} onClick={handleSubmit}>Update User</Button>
                </div>
            </DialogClose>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    )
  }
